import { useEventStore } from 'Store/eventStore'
import { usePostStore } from 'Store/postStore'
import { useUserStore } from 'Store/userStore'

useEventStore.subscribe(async (state, oldState) => {
      if (state.event?.id !== oldState.event?.id) {
            console.log('eventChanged: ', oldState.event?.id, ' -> ', state.event?.id)
            // await usePostStore.getState().init()
            // await usePostStore.getState().getPosts()
      }
})

useUserStore.subscribe(async (state, oldState) => {
      if (state.user?.id !== oldState.user?.id) {
            console.log('userChanged: ', oldState.user?.id, ' -> ', state.user?.id)
      }
})
